function capitalise(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
function switchOneTwoThree (num) {
    switch (num) {
        case 0:
        num = ""
        break
        case 1:
        num = "one"
        break
        case 2:
        num = "two"
        break
        case 3:
        num = "three"
        break
        case 4:
        num = "four"
        break
        case 5:
        num = "five"
        break
        case 6:
        num = "six"
        break
        case 7:
        num = "seven"
        break
        case 8:
        num = "eight"
        break
        case 9:
        num = "nine"
        break
    }
    return num
}
function switchTeens (num) {
    switch (num) {
        case 0:
        num = ""
        break
        case 11:
        num = "eleven"
        break
        case 12:
        num = "twelve"
        break
        case 13:
        num = "thirteen"
        break
        case 14:
        num = "fourteen"
        break
        case 15:
        num = "fifteen"
        break
        case 16:
        num = "sixteen"
        break
        case 17:
        num = "seventeen"
        break
        case 18:
        num = "eighteen"
        break
        case 19:
        num = "nineteen"
        break
    }
    return num
}
function switchTwentyThirtyForty (num) {
    switch (num) {
        case 0:
        num = ""
        break
        case 1:
        num = "ten"
        break
        case 2:
        num = "twenty"
        break
        case 3:
        num = "thirty"
        break
        case 4:
        num = "forty"
        break
        case 5:
        num = "fifty"
        break
        case 6:
        num = "sixty"
        break
        case 7:
        num = "seventy"
        break
        case 8:
        num = "eighty"
        break
        case 9:
        num = "ninety"
        break
    }
    return num
}

export function intToString(int2String, leadingUcase) {
    var answer = ''
    if (int2String != 0){
        if(!isNaN(int2String)) {
            var hundreds = Math.floor(int2String/100)
            var tens = Math.floor(int2String/10 - (hundreds * 10))
            var units = Math.floor(int2String - (tens * 10) - (hundreds * 100))
            var teens = 0
            if (hundreds !== 0) {
                answer = answer + switchOneTwoThree(hundreds) + ' hundred'
                if ((tens != 0) || (units != 0)) {
                    //this allows for teens as well
                    answer = answer + ' and ' 
                } 
            }        
            if ((tens === 1) && (units != 0)) {
                teens = tens * 10 + units
                answer = answer + switchTeens(teens)    
            } else {
                var tenText = switchTwentyThirtyForty(tens)
                var unitText = switchOneTwoThree(units)
                var joinText = ''
                if (tenText.length != 0 && unitText.length !=0) {
                    var joinText = '-'
                }
                answer = answer + tenText + joinText + unitText         
            }
            //console.log('hundreds ' + hundreds + ' tens ' + tens + ' units ' + units + ' teens ' + teens + '.')    
        } else {
            answer = 'not working'
        }
    } else {
        answer = 'member'
    }
    if (leadingUcase) { 
        answer = capitalise(answer)
    } 
    return answer
}
